// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_eV","advertDetailContacts__header":"c-n_eW"};